import { Box } from "@chakra-ui/react";
import React from "react";

const IconHover = ({ text, isCustomAssessment = false }) => {
  return (
    <Box
      width={"200px"}
      height={"max-content"}
      bgColor={"#FFF8F7"}
      padding={"8px"}
      gap={"8px"}
      borderRadius={"6px"}
      borderWidth={"1px"}
      borderColor={"#E5E7EB"}
      color={"#7464CE"}
      boxShadow={"0px 4px 4px 0px #AEAEAE40"}
      fontSize={"10px"}
      fontWeight={"600"}
      lineHeight={"14px"}
      fontFamily={"Poppins, Text-xs/Semibold"}
      position={"absolute"}
      left={isCustomAssessment ? "0%" : "100%"} // Positioning it to the right of the button
      top={"10%"}
      transform={"translateY(-50%)"} // Centering vertically
      marginLeft={isCustomAssessment ? "-208px" : "8px"} // Adding a little space between the button and hover
      zIndex={"1000"}
    >
      {text}
    </Box>
  );
};

export default IconHover;
